import restApi from '../../http-common'
// import swal from 'sweetalert2'
import VueRouter from 'vue-router'
import api from '../../services/api'
import swal from "sweetalert2";

const router = new VueRouter();
const apiService = new api();

export default {
    name: 'login',
    data() {
        return {
            backendError: null,
            model: {
                email: '',
                password: ''
            }
        }
    },
    methods: {

        onTextChange(){
            this.backendError = null
        },

        keymonitor(event) {
            if(event.key === 'Enter') {
                this.login();
            }
        },

    },
    components: {},
    beforeMount() {

    }
}


// WEBPACK FOOTER //
// ./src/components/Account/DeleteAccount.js